module.exports = __webpack_public_path__ + "static/media/tour-game.c7c0af40.png";